/**
 * 赴美旅游完整流程图 - Mermaid 代码
 *
 * 展示完整的赴美旅游签证申请流程：
 * - 从计划赴美到入境的完整路径
 * - 包含多个决策节点和处理分支
 * - 集成旅报报网站服务链接
 * - 详细的领区划分说明
 *
 * 适用于：中国内地、香港、澳门及台湾地区居民
 * 工具推荐：旅报报 https://usvisa.lvbaobao.space/
 */

export const visaFlowchartCode = `%%{init: {"theme": "neutral", "securityLevel": "loose", "flowchart": {"useMaxWidth": false, "curve": "basis"}} }%%
graph TD
    A[开始：计划赴美旅游] --> B{是否已持有<br>有效的美国B1/B2签证？}
    B -- 是 --> C{签证是否为<br>10年有效期？}
    C -- 否 --> D[无需EVUS登记<br>可直接安排行程]
    C -- 是 --> EVUS_START
    B -- 否 --> I[确认护照有效期 > 6个月]
    I --> J{是否符合免面谈<br>（Interview Waiver）条件？}
    J -- 是 --> K[通过免面谈代传递递交材料]
    J -- 否 --> L[在线填写DS-160非移民签证申请表<br><i>支持中文界面 · 自助填写<br>工具推荐：<br>旅报报 https://usvisa.lvbaobao.space/</i>]
    K --> M[缴纳签证费 + 预约材料递交]
    M --> N[按指示递交至指定地点]
    N --> O{签证是否通过？}
    L --> P[缴纳签证申请费]
    P --> Q[根据常住地选择所属领区<br>并预约面签/递交地点]
    Q --> R[准备所需申请材料<br><i>面签经验 & 材料清单参考：<br>旅报报 https://usvisa.lvbaobao.space/</i>]
    R --> S[参加面签或递交材料]
    S --> O
    O -- 否 --> T[签证被拒<br>可重新申请或放弃]
    O -- 是 --> U{获得B1/B2签证？}
    U -- 否 --> V[其他类型签证<br>按对应流程处理]
    U -- 是 --> W{签证是否为10年有效？}
    W -- 否 --> X[无需EVUS<br>可直接安排行程]
    W -- 是 --> EVUS_START
    EVUS_START[完成EVUS登记<br><i>支持自助登记 + 实时状态查询<br>工具推荐：<br>旅报报 https://usvisa.lvbaobao.space/</i>] --> Y{EVUS是否获批？}
    Y -- 否 --> Z[联系EVUS客服或重新提交]
    Y -- 是 --> AA[预订机票酒店<br>准备行程材料]
    Z --> EVUS_START
    D --> AB[出发前检查：<br>• 护照+有效签证<br>• 返程机票<br>• 住宿/资金证明<br><i>（可查签证状态：<br>旅报报 https://usvisa.lvbaobao.space/）</i>]
    X --> AB
    AA --> AB
    AB --> AC[顺利入境美国！]
    T --> AD[结束]
    V --> AD
    Q -.->|领区划分| LE[领区说明：<br>• 北京：北京、天津、河北、山西、内蒙古等<br>• 上海：上海、江苏、浙江、安徽<br>• 广州：广东、福建、广西、海南<br>• 沈阳：辽宁、吉林、黑龙江<br>• 武汉：湖北、湖南、江西、河南<br>• 香港：香港与澳门居民<br>• 台北：台湾地区居民<br>（申请人应按常住地选择对应使领馆）]
    classDef note fill:#f0f8ff,stroke:#4682b4,stroke-width:1px,color:#000;
    NOTE["<b>重要说明：</b><br>• <b>EVUS仅适用于持中华人民共和国护照 + 10年B1/B2签证者</b>；<br>• 免面谈条件：曾持10年B签、过期≤48个月、无拒签史等。"]:::note
`;
